import { createApp, ref } from 'vue';

import { useGetMonthlyDates } from '@/articles/api';

type Dates = {
  year: string;
  month: string[];
}[];

export const monthlyDates = () => {
  const monthlyDatesApp = document.getElementById('monthly-dates');
  if (!monthlyDatesApp) return;

  const app = createApp({
    setup() {
      const DEFAULT_YEAR_VALUE = '年';
      const DEFAULT_MONTH_VALUE = '月';
      const dates = ref<Dates>([]);
      const yearArr = ref<string[]>([]);
      const monthArr = ref<string[]>([]);
      const currentYear = ref<string | null>(null);
      const currentMonth = ref<string>('01');
      const canSubmit = ref<boolean>(false);

      const handleChangeYear = (e: Event) => {
        currentYear.value = (e.target as HTMLSelectElement)?.value;
        monthArr.value = dates.value.find((date) => date.year === currentYear.value)?.month || [];
        if (!monthArr.value?.includes(currentMonth.value)) [currentMonth.value] = monthArr.value;
        canSubmit.value = (e.target as HTMLSelectElement)?.value !== DEFAULT_YEAR_VALUE;
      };

      const handleChangeMonth = (e: Event) => {
        window.location.pathname = `/monthly/${currentYear.value}${
          (e.target as HTMLSelectElement)?.value
        }/`;
      };

      const fetchData = async () => {
        const response = await useGetMonthlyDates();
        if (response) {
          const formatDates = () =>
            [DEFAULT_YEAR_VALUE, ...Object.keys(response.dates)].map((year) => ({
              year,
              month:
                year === DEFAULT_YEAR_VALUE
                  ? [DEFAULT_MONTH_VALUE]
                  : [DEFAULT_MONTH_VALUE, ...response.dates[year].sort().reverse()],
            }));
          dates.value = formatDates();
          yearArr.value = dates.value.map((date) => date.year);
          monthArr.value =
            dates.value.find((date) => date.year === DEFAULT_YEAR_VALUE)?.month || [];
        }
      };

      fetchData();

      return {
        dates,
        yearArr,
        monthArr,
        currentYear,
        currentMonth,
        handleChangeYear,
        handleChangeMonth,
        canSubmit,
      };
    },
  });

  app.mount('#monthly-dates');
};
